module.exports = __webpack_public_path__ + "img/place-24px.a9efc0d9.svg";